import React, { useState } from "react";
import { RouteComponentProps, Redirect } from "react-router";
import styled from "@emotion/styled/macro";

import { ICachedData, IUser, getPrizeImage } from "../ApiService";
import BobbleFooter from "../common/BobbleFooter";
import ModelViewer, { ModelState } from "../BobbleContent/ModelViewer";
//import EventInfoDialog from "../Dialogs/EventInfoDialog";

import baseSideTexturePath from "../BobbleContent/baseSideTexture.jpg";
import baseTexturePath from "../BobbleContent/baseTexture.png";
import scratchImagePath from "../BobbleContent/scratch.png";

import arrow from "../res/i_arrow.svg";
import IBobbleViewProps from "../BobbleContent/IBobbleViewProps";

type Props = IBobbleViewProps & {
  collectedBobbleheadIds: string[];
  cachedData: ICachedData;
  signedInUser: IUser;
};

const Root = styled("div")`
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Arrows = styled("div")`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  width: 100%;
`;

const Arrow = styled("button")`
  width: 44px;
  border: none;
  background: url(${arrow}) no-repeat center center transparent;
  background-size: 32px;
  padding: 0;
  position: absolute;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`;

const LeftArrow = styled(Arrow)`
  transform: rotate(180deg);
  align-self: flex-start;
  left: 0;
`;

const RightArrow = styled(Arrow)`
  align-self: flex-end;
  right: 0;
`;

export default function CarouselItem({
  cachedData,
  collectedBobbleheadIds,
  history,
  match: {
    params: { bobbleheadId }
  },
  signedInUser,
  ...rest
}: Props & RouteComponentProps<{ bobbleheadId: string }>) {
  const [isShowingEventInfo, setIsShowingEventInfo] = useState(false);
  const [modelState, setModelState] = useState<ModelState>("Default");

  const myIndex = collectedBobbleheadIds.indexOf(bobbleheadId);
  if (myIndex === -1) {
    return <Redirect to={`/collection${window.location.search}`} />;
  }
  const bobblehead = cachedData.bobbleheads[bobbleheadId];
  //const collectedDate = collectedBobbleheadDates[myIndex];
  //console.log(cachedData);
  const {
    modelScaleFactor,
    modelOffsetY,
    baseScaleFactor,
    baseOffsetY
  } = bobblehead;

  const goToBobble = (change: number) => {
    history.push(
      `/collection/${collectedBobbleheadIds[myIndex + change]}${
        window.location.search
      }`
    );
  };

  return (
    <Root>
      <ModelViewer
        {...rest}
        interactionsEnabled
        modelPath={bobblehead.modelUrl}
        rewardPath={getPrizeImage(signedInUser, bobblehead)}
        showButtons={true}
        scratchImagePath=""
        baseTexturePath={bobblehead.baseTextureUrl}
        cubeSidePath={bobblehead.baseSideTextureUrl}
        modelState={modelState}
        changeModelState={setModelState}
        modelScaleFactor={bobblehead.modelScaleFactor}
        modelOffsetY={bobblehead.modelOffsetY}
        baseScaleFactor={bobblehead.baseScaleFactor}
        baseOffsetY={bobblehead.baseOffsetY}
        isScratched={true}
        hasRotatedModel={true}
        onScratchComplete={() => {
          // TODO: bonus scratched
        }}
      />
      {/*false && collectedBobbleheadIds.length > 1 && (
        <Arrows>
          {myIndex > 0 && (
            <LeftArrow
              onClick={() => {
                goToBobble(-1);
              }}
            />
          )}
          {myIndex < collectedBobbleheadIds.length - 1 && (
            <RightArrow
              onClick={() => {
                goToBobble(1);
              }}
            />
          )}
        </Arrows>
            )*/}
      <BobbleFooter
        mainComponent={<div></div>}
        showEventInfo={() => setIsShowingEventInfo(true)}
      />
      {/*isShowingEventInfo && (
        <EventInfoDialog
          collectedDate={collectedDate}
          onClose={() => {
            setIsShowingEventInfo(false);
          }}
        />
        )*/}
    </Root>
  );
}
